// extracted by mini-css-extract-plugin
export default {"button":"NavigationLink_button__+usfN","active":"NavigationLink_active__NlGAF"};